module.exports = __webpack_public_path__ + "media/images/screen-shot-2021-02-10-at-2-23-1-1@2x-33f946209838f6ac2b6cbf94ecbb9fe8.png";